export const ALLERGY = 600100;
export const INTOLERANCE = 600101;

export const FOOD = 601102;
export const MEDICATION = 601103;
export const ENVIRONMENT = 601104;
export const BIOLOGIC = 601105;